export default __webpack_public_path__ + "static/media/Grandeur_large_8.a2b71f3a.jpg";